<template>
  <div>
    <member-page-title :title="$t('promo.coupon.title')" />
    <promo-input
      :is-title-shown="true"
      class="px-5 pb-6 md:pt-6"
      input-box-class="flex-none w-full md:w-80"
      input-container-class="flex-col gap-4 md:flex-row md:gap-5"
      claim-btn-class="self-auto md:self-baseline"
      :on-receive-promo-success="refreshPromoCodes.bind(null, undefined)"
    />
    <member-tabs default-value="active">
      <n-tab-pane name="active" :tab="$t('promo.tab.usable')">
        <coupon-list type="active" :list="promoCodes?.active" :is-promo-codes-loading="isPromoCodesLoading" />
      </n-tab-pane>
      <n-tab-pane name="inactive" :tab="$t('promo.tab.expired')">
        <coupon-list type="inactive" :list="promoCodes?.inactive" :is-promo-codes-loading="isPromoCodesLoading" />
      </n-tab-pane>
    </member-tabs>
  </div>
</template>

<script setup lang="ts">
import { NTabPane } from 'naive-ui'

import MemberPageTitle from '@/components/member/member-page-title.vue'
import MemberTabs from '@/components/member/member-tabs.vue'
import CouponList from '@/components/member/coupons/coupon-list.vue'
import PromoInput from '@/components/promo/promo-input.vue'

definePageMeta({
  layout: 'member',
  middleware: ['auth-required'],
})

const { promoCodes, isPromoCodesLoading, refreshPromoCodes } = useGetPromoCodes()
</script>
